<template>
  <v-container>
    <v-layout row wrap mt-4>
      <v-flex xs12 md3 pr-4>
        <v-text-field
          label="Facilitator"
          v-model="search.UserName"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md3 pr-4>
        <v-text-field
          label="Site"
          v-model="search.Site"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-4 justify-end>
      <v-btn color="secondary" @click="search={UserName: '', Site: ''}">Clear</v-btn>
      <v-btn color="primary" @click="getFiltered(search)">Search</v-btn>
    </v-layout>
    <v-layout row wrap mt-4 justify-end>
      <v-btn color="primary" @click="item={ID: 0, SiteID: 0, UserID: 0}; dialog=true">add new site facilitator</v-btn>
    </v-layout>  
    <v-data-table
      :items="filtered"
      :headers="headers"
    >
      <template slot="items" slot-scope="props">
        <tr style="text-align:left;">
          <td>
            <v-btn icon color="primary" @click="edit(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon color="primary" @click="deleteUsers_Sites(props.item)">
              <v-icon>delete_forever</v-icon>
            </v-btn>
          </td>
          <td>{{props.item.User.FirstName}} {{props.item.User.LastName}} ({{props.item.User.UserName}})</td>
          <td>{{props.item.Site.SiteInsitutionName}}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      max-width="850px"
    >
    <v-card>
      <v-card-text>
        <v-facilitator
          label="Facilitator"
          v-model="item.UserID"
        ></v-facilitator>
        <v-sites
          label="Site"
          v-model="item.SiteID"
        ></v-sites>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="item.ID > 0" color="primary" @click="updateUsers_Sites(item); dialog=false">Save</v-btn>
        <v-btn v-else color="primary" @click="createUsers_Sites(item); dialog=false">Save</v-btn>
        <v-btn color="secondary" @click="dialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const moduleNameSpace = 'usersSites'
import { mapGetters, mapActions } from 'vuex'
import LuFacilitatorsVue from './LuFacilitators.vue';
import SiteAddressVue from '../SiteAddress.vue';
export default {
  data(){
    return {
      search: {
        UserName: '',
        Site: ''
      },
      headers: [
        {text: '', value: '', sortable: false},
        {text: 'Facilitator', value: 'UserName'},
        {text: 'Site', value: 'SiteInsitutionName'},
      ],
      item: {},
      dialog: false,
    }
  },
  created(){
    this.getFiltered(this.search)
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getFiltered', 'updateUsers_Sites', 'createUsers_Sites', 'deleteUsers_Sites']),
    edit(val){
      this.item = {}
      this.item = JSON.parse(JSON.stringify(val))
      this.dialog = true
    },
  },
  computed: {
    ...mapGetters(moduleNameSpace, ['filtered'])
  },
  components: {
    'v-facilitator' : LuFacilitatorsVue,
    'v-sites' : SiteAddressVue
  }
}
</script>

<style>

</style>
